import api from './api';

export const teacherService = {
  // Get dashboard data
  async getDashboard() {
    const response = await api.get('/teacher/dashboard');
    return response.data;
  },

  // Get all students for teacher's school
  async getStudents() {
    const response = await api.get('/students');
    // API returns {students: [], total: N}, extract just the array
    return response.data.students || response.data;
  },

  // Get single student with progress details
  async getStudent(studentId) {
    const response = await api.get(`/students/${studentId}`);
    return response.data;
  },

  // Create a new student
  async createStudent(data) {
    const response = await api.post('/students', {
      name: data.name,
      avatar: data.avatar,
      grade: data.grade,
      pin: data.pin,
    });
    return response.data;
  },

  // Update a student
  async updateStudent(studentId, data) {
    const response = await api.put(`/students/${studentId}`, data);
    return response.data;
  },

  // Delete a student
  async deleteStudent(studentId) {
    const response = await api.delete(`/students/${studentId}`);
    return response.data;
  },

  // Get student progress (basic)
  async getStudentProgress(studentId) {
    const response = await api.get(`/students/${studentId}/progress/detailed`);
    return response.data;
  },

  // Get recent activity for dashboard
  async getRecentActivity(limit = 10) {
    const response = await api.get('/teacher/activity', {
      params: { limit },
    });
    return response.data;
  },

  // Get class statistics
  async getClassStats() {
    const response = await api.get('/teacher/stats');
    return response.data;
  },

  // Get progress overview for all students
  async getProgressOverview() {
    const response = await api.get('/teacher/progress');
    return response.data;
  },

  // Get all certificates issued
  async getCertificates() {
    const response = await api.get('/teacher/certificates');
    return response.data;
  },

  // Get certificate eligibility for all students
  async getCertificateEligibility() {
    const response = await api.get('/teacher/certificates/eligibility');
    return response.data;
  },

  // Issue a certificate to a student
  async issueCertificate(data) {
    const response = await api.post('/teacher/certificates/issue', data);
    return response.data;
  },
};

export default teacherService;
